module.exports = __webpack_public_path__ + "static/media/Wounds.e9687496.svg";